/* Source-proven defaults: Brown cases, source exclusion count, no source runtime date predicate. Original copy/dates unchanged. */
window.pnCaseGiftConfig = {
  "version": 1,
  "campaignId": "source-0909-case-gift",
  "enabled": false,
  "approvalReference": "Owner instruction: reproduce currently demonstrated source behavior; source-native-checkout.json and source-case-controller.js",
  "validityMode": "source-runtime-no-date-check",
  "sourceVerifiedAt": "2026-09-10T04:30:59.281Z",
  "startsAt": null,
  "endsAt": null,
  "noExpiryApproved": false,
  "countingMode": "source-excluded-variants",
  "excludedVariantIds": [
    52880875094245,
    52880873390309,
    52880875520229,
    null
  ],
  "sourceAdvertisedValidity": "Through September 9th; offer ends 09.09 (year/timezone not specified in copy)",
  "eligibleProductIds": [
    9799231799525,
    9799231340773,
    9799231668453,
    9799231570149,
    9799231897829,
    9799231930597,
    9799228883173,
    9799230816485,
    9799229866213,
    9799231045861,
    9799228358885,
    9799230128357,
    9799232848101,
    9799230947557,
    9799228588261,
    9799229178085,
    9799229767909,
    9799232946405,
    9799229538533,
    9799230357733,
    9799228686565,
    9799230226661,
    9799232159973,
    9799228457189,
    9799229997285,
    9799228784869,
    9799229309157,
    9799232717029,
    9799229440229,
    9799232520421,
    9799233044709,
    9799232389349,
    9799232291045,
    9799230587109,
    9799232061669,
    9799230488805,
    9799232618725,
    9799229669605,
    9799231144165,
    9799230718181
  ],
  "braceletVariantId": 52880875094245,
  "quantityPerCart": 1,
  "tiers": [
    {
      "minimumWatches": 2,
      "capacity": 2,
      "handle": "elegant-double-watch-case",
      "productId": 9799233143013,
      "selectedVariantId": 52880873390309,
      "variants": [
        {
          "color": "Black",
          "sourceVariantId": 43440897261658,
          "variantId": 52880873357541,
          "sku": null,
          "sizeOption": null
        },
        {
          "color": "Brown",
          "sourceVariantId": 43440897294426,
          "variantId": 52880873390309,
          "sku": null,
          "sizeOption": null
        }
      ]
    },
    {
      "minimumWatches": 3,
      "capacity": 3,
      "handle": "triple-watch-leather-case",
      "productId": 9799233601765,
      "selectedVariantId": 52880875520229,
      "variants": [
        {
          "color": "Black",
          "sourceVariantId": 43440897589338,
          "variantId": 52880875487461,
          "sku": null,
          "sizeOption": null
        },
        {
          "color": "Brown",
          "sourceVariantId": 43440897622106,
          "variantId": 52880875520229,
          "sku": null,
          "sizeOption": null
        }
      ]
    },
    {
      "minimumWatches": 4,
      "capacity": 4,
      "handle": "quad-watch-leather-case",
      "productId": null,
      "selectedVariantId": null,
      "variants": [
        {
          "color": "Black",
          "sourceVariantId": 44032673611866,
          "variantId": null,
          "sku": null,
          "sizeOption": null
        },
        {
          "color": "Brown",
          "sourceVariantId": 44032673644634,
          "variantId": null,
          "sku": null,
          "sizeOption": null
        }
      ]
    }
  ],
  "restorationBlockedReason": "Awaiting owner decision: Double/Triple prices and missing Quad. All tiers preserved; zero-price guard unchanged."
};
